import { toast } from "../components/common/toast";
import { blockedAction } from "../components/common/blockedAction";
import { getApiErrorMessage } from "./apiError";

/**
 * Reports a failed delete. When the API explained why (a rule refusal such
 * as "still used by 2 active contracts: …"), the reason opens in a modal
 * the user must dismiss; an unexplained failure falls back to the usual
 * short error toast. Returns the message that was shown.
 */
export function reportDeleteFailure(err: unknown, fallback: string): string {
  const message = getApiErrorMessage(err, fallback);
  if (message === fallback) {
    toast.error(fallback);
  } else {
    blockedAction.show({ message });
  }
  return message;
}
